export default __webpack_public_path__ + "static/media/signature logo.75272c99.png";